/**
 * @description Gets the value of the affiliate-awc cookie if it exists
 * @returns {string | null} The cookie value or null if it doesn't exist
 */
export const getAffiliateAwc = (): string | null => {
  if (typeof document === "undefined") return null;

  const value = `; ${document.cookie}`;
  const parts = value.split("; affiliate-awc=");
  if (parts.length === 2) return parts.pop()?.split(";").shift() || null;
  return null;
};

/**
 * @description Deletes the affiliate-awc cookie
 */
export const deleteAffiliateAwc = (): void => {
  if (typeof document === "undefined") return;

  document.cookie =
    "affiliate-awc=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
};
